import React, { useState, useEffect, useRef } from "react"
import ModalRar from "@components/ModalRar"
import { InitLoadHook } from "@utils/GetInitLoad"

import tw from "twin.macro"
import { buttonGreenPurple } from "@styles/ui"

const RarTab = ({ location, stickyIsiMaxHeight }) => {
  const [screenshotMode, setScreenshotMode] = useState(null)
  const [showTab, setShowTab] = useState(false)
  const [hideButton, setHideButton] = useState(false)

  const initLoad = InitLoadHook()

  const toggleTab = () => {
    setShowTab(!showTab)
  }

  const ref = useRef(null)

  useEffect(() => {
    if (location?.search.includes("rarModalEmpty=1")) {
      setScreenshotMode("empty")
    } else if (location?.search.includes("rarModalSuccess=1")) {
      setScreenshotMode("success")
    } else if (location?.search.includes("rarModalServer=1")) {
      setScreenshotMode("server-error")
    } else if (location?.search.includes("rarModalErrors=1")) {
      setScreenshotMode("errors")
    } else if (location?.search.includes("rarPanel=1")) {
      setScreenshotMode("panel")
    }
  }, [location?.search])

  useEffect(() => {
    if (location && location.pathname.indexOf('request-a-rep') !== -1) {
      setHideButton(true);
    }
  }, [location])

  const [loadTab, setLoadTab] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setLoadTab(true)
    }, 500)
  }, [initLoad])

  return (
    <>
        {!hideButton && (
      <div
      data-id="rar-tab"
      css={[
        `top: calc(100% - ${stickyIsiMaxHeight}px);`,
        tw`fixed z-30 -translate-y-[calc(100%+16px)] right-0 translate-x-full transition-all duration-300`,
        tw`md:(top-1/2 -translate-y-1/2)`,
        showTab && tw`translate-x-0`,
      ]}
    >
      <button
        ref={ref}
        aira-controls="rar-panel"
        data-id="rar-trigger"
        onClick={toggleTab}
        aria-expanded={showTab}
        tw=""
        css={[
          tw`bg-green text-purple text-sm leading-normal font-extrabold uppercase py-3 px-4 rounded-t-2xl hover:(bg-purple text-tan)`,
          tw`absolute transition-all duration-300 bottom-0 -rotate-90 origin-bottom-left translate-x-full`,
          loadTab && tw`translate-x-0`,
        ]}
      >
        Request a rep
      </button>
      <div
        id="rar-panel"
        data-id="rar-panel"
        data-expanded={showTab}
        css={[
          tw`w-[12.9375rem] p-4 bg-tan text-black rounded-tl-2xl invisible transition-all duration-300 lg:(w-[16rem] p-6 transform)`,
          showTab && tw`visible`,
        ]}
      >
        <p tw="font-kanit tracking-[0.005rem] font-bold text-xl mb-2 leading-none lg:(mb-4 text-2xl leading-[1.05])">
          Speak with a representative
        </p>
        <p tw="mb-2 text-sm leading-[1.1] lg:(mb-4 text-lg leading-[1.2])">
          Have questions about DefenCath? Open the form below to request a call
          with a representative.
        </p>
        <a href="/request-a-rep"
        css={[buttonGreenPurple, tw`block lg:(w-[11.8125rem])`]}>Open form</a>
        {/* <ModalRar
          additionalAction={toggleTab}
          screenshotState={screenshotMode}
          triggerContent="Open form"
          triggerStyles={[buttonGreenPurple, tw`lg:(w-[11.8125rem])`]}
        /> */}
      </div>
    </div>
    )}
    </>


  )
}

export default RarTab
